import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { PropTypes as MobxPropTypes } from 'mobx-react'
import { transport, channel, sessionStorage } from '../../../lib/services'
import { eventBus } from '../../../lib/utils/dom'
import { fromServerToClient } from '../../../lib/utils/collection'
import ListingsMapStore from './stores/ListingsMapStore'
import ErrorBoundary from '../../Shared/ErrorBoundary'
import Viewport from '../../Shared/Viewport'
import SearchResultsMapDesktop from './SearchResultsMapDesktop'
import SearchResultsMapMobile from './SearchResultsMapMobile'
import MapStore from './stores/MapStore'
import { useRegisterGlobalActions } from '../../../shared_components/Hooks'

const store = new ListingsMapStore({
  transport,
  channel,
  eventBus,
  sessionStorage
})
const mapStore = new MapStore({ eventBus })

const SearchResultsMap = ({
  header,
  collection,
  cardPreviewClass,
  layout,
  mapBounds,
  searchPolygon,
  onSubmitSearch,
  onBoundsChanged,
  onSearchPolygonChanged,
  onSubmitPolygon,
  useHandDrawing,
  usePropertyPolygons,
  showListingCount,
  valueStateStore
}) => {
  store.setInitialState({
    collection: fromServerToClient(collection),
    header: header
  })

  useRegisterGlobalActions({
    context: store,
    key: 'SearchResultsMap',
    actions: ['updateSaveStatus']
  })

  useEffect(() => {
    store.fetchCollection({ isFirstFetch: true })
    store.updateListingViewedStatus()

    return () => {
      store.resetStore()
    }
  }, [])

  return (
    <ErrorBoundary>
      <Viewport only='desktop'>
        <SearchResultsMapDesktop
          header={header}
          cardPreviewClass={cardPreviewClass}
          layout={layout}
          mapBounds={mapBounds}
          searchPolygon={searchPolygon}
          onSubmitSearch={onSubmitSearch}
          onBoundsChanged={onBoundsChanged}
          onSearchPolygonChanged={onSearchPolygonChanged}
          onSubmitPolygon={onSubmitPolygon}
          useHandDrawing={useHandDrawing}
          usePropertyPolygons={usePropertyPolygons}
          store={store}
          mapStore={mapStore}
          showListingCount={showListingCount}
          valueStateStore={valueStateStore}
        />
      </Viewport>
      <Viewport except='desktop'>
        <SearchResultsMapMobile
          header={header}
          cardPreviewClass={cardPreviewClass}
          mapBounds={mapBounds}
          searchPolygon={searchPolygon}
          onSubmitSearch={onSubmitSearch}
          onBoundsChanged={onBoundsChanged}
          onSearchPolygonChanged={onSearchPolygonChanged}
          onSubmitPolygon={onSubmitPolygon}
          useHandDrawing={useHandDrawing}
          usePropertyPolygons={usePropertyPolygons}
          store={store}
          mapStore={mapStore}
          totalHomes={showListingCount && collection.length}
          showListingCount={showListingCount}
          valueStateStore={valueStateStore}
        />
      </Viewport>
    </ErrorBoundary>
  )
}

SearchResultsMap.propTypes = {
  header: PropTypes.string,
  collection: MobxPropTypes.arrayOrObservableArray,
  cardPreviewClass: PropTypes.string,
  layout: PropTypes.string,
  mapBounds: MobxPropTypes.objectOrObservableObject,
  searchPolygon: MobxPropTypes.arrayOrObservableArray,
  onSubmitSearch: PropTypes.func,
  onBoundsChanged: PropTypes.func,
  onSearchPolygonChanged: PropTypes.func,
  onSubmitPolygon: PropTypes.func,
  useHandDrawing: PropTypes.bool,
  usePropertyPolygons: PropTypes.bool,
  showListingCount: PropTypes.bool,
  valueStateStore: PropTypes.object,
  searchParams: PropTypes.shape({
    url: PropTypes.string.isRequired,
    query: PropTypes.shape({}).isRequired
  })
}

SearchResultsMap.defaultProps = {
  cardPreviewClass: '',
  showListingCount: false,
  header: ''
}

export default SearchResultsMap
